import { settings } from "vino/settings";
import clsx from "clsx";

const DefaultImage = ({ className }) => {
	const url = `${
		settings.VINO_PLUGIN_URL || "../assets/"
	}images/default-wine-bottle.jpg`;
	return (
		<img
			src={url}
			alt=""
			className={clsx("h-full w-full object-contain object-center")}
		/>
	);
};

export default DefaultImage;
